import {
  Component,
  OnInit,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  ElementRef,
} from "@angular/core";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  AbstractControl,
} from "@angular/forms";
import {
  KreFormOptions,
  FieldWrapper,
  KreFormFieldConfig,
  clone,
  KreTableFieldConfig,
  Field,
  KreFormCommonService,
  IItem,
  IParameterIdItem,
} from "@kre-form/core";
import { BehaviorSubject } from "rxjs";
import { KreSetFormFieldService } from "../../tools/setField.service";
import * as _ from "lodash";
import * as moment_ from "moment";
const moment = moment_;
@Component({
  selector: "kreform-ds_field",
  templateUrl: "./index.component.html",
  styleUrls: ["./index.component.less"],
  providers: [KreSetFormFieldService],
})
export class KreFormDSField implements OnInit, OnChanges, OnDestroy {
  formField: any = {
    key: "",
    type: "",
    templateOptions: {
      type: null,
      label: null,
      description: null,
      parameterId: null,
      maxLength: null,
      minLength: null,
      max: null,
      min: null,
      precision: null,
      placeholder: null,
      required: false,
      tips: null,
      pattern: null,
      rows: 4,
      hideSelect: null,
      selectType: "single",
      labelI18n: [],
      tipsI18n: [],
    },
    fontProperty: {
      fontSize: 14,
      color: "#323232",
      fontWeight: false,
      fontStyle: false,
    },
    defaultValue: null,
    editProperty: {
      config: true,
    },
    show: true,
    hide: false,
  };
  fontSizeList: number[] = [];

  defaultList: IItem[] = [];
  defaultValue: any = null;
  hideSelect: string[] = [];

  _langConfig: any[] = [];
  @Input()
  set langConfig(value: any) {
    this._langConfig = value;
  }
  get langConfig() {
    return this._langConfig;
  }
  limit: any = {
    maxLength: null,
    minLength: null,
    max: null,
    min: null,
    maxDate: null,
    minDate: null,
  };

  @Input() set field(value: KreFormFieldConfig) {
    _.assignIn(this.formField, _.cloneDeep(value));

    if (this.formField.type === "textarea" && this.formField.templateOptions) {
      if (
        this.formField.templateOptions.rows === undefined ||
        this.formField.templateOptions.rows === null
      ) {
        this.formField.templateOptions.rows = 4;
      }
    }
    if (
      this.formField.type === "datetime" &&
      this.formField!.templateOptions!.type === "time" &&
      !!this.formField.defaultValue
    ) {
      this.formField.defaultValue = new Date(this.formField.defaultValue);
    }
    if (this.formField.type === "select") {
      if (this.formField.templateOptions.selectType === "multiple") {
        this.defaultValue = [];
        if (!_.isEmpty(this.formField.defaultValue)) {
          (this.formField.defaultValue as IItem[]).forEach((el) => {
            this.defaultValue.push(el.value);
          });
        }
      } else {
        this.defaultValue = null;

        if (!_.isEmpty(this.formField.defaultValue)) {
          this.defaultValue = this.formField.defaultValue[0].value;
        }
      }
    }
    if (
      this.formField.type === "select" &&
      !_.isEmpty(this.formField!.templateOptions!.hideSelect)
    ) {
      (this.formField.templateOptions!.hideSelect as IItem[]).forEach((el) => {
        this.hideSelect.push(el.value);
      });
    }

    this.formField.hide = !this.formField["show"];
    this.newPrimitive(this.formField);
    // if (!this.formField!.templateOptions!.labelI18n) {
    //   this.formField!.templateOptions!.labelI18n = this.langConfig;
    // }
    // if (!this.formField!.templateOptions!.tipsI18n) {
    //   this.formField!.templateOptions!.tipsI18n = this.langConfig;
    // }
    // if (
    //   !!this.formField!.templateOptions!.label &&
    //   !(this.formField!.templateOptions!.labelI18n as any[]).filter(
    //     (el) => el.language === "zh-cn"
    //   )[0].value
    // ) {
    //   (this.formField!.templateOptions!.labelI18n as any[]).filter(
    //     (el) => el.language === "zh-cn"
    //   )[0].value = this.formField!.templateOptions!.label;
    // }
    this.limit.min = -999999;
    if (
      !!this.formField!.primitiveProperty!.min ||
      this.formField!.primitiveProperty!.min === 0
    ) {
      this.limit.min = this.formField!.primitiveProperty!.min;
    }

    this.limit.max = this.formField!.primitiveProperty!.max || 999999;
    this.limit.minLength = this.formField!.primitiveProperty!.minLength || 0;
    this.limit.maxLength = this.formField!.primitiveProperty!.maxLength || 500;

    this.limit.maxDate =
      this.formField!.primitiveProperty!.maxDate || "2050-12-31";
    this.limit.minDate =
      this.formField!.primitiveProperty!.minDate || "1900-01-01";
  }

  newPrimitive(value: any) {
    if (
      value.primitiveProperty === null ||
      value.primitiveProperty === undefined
    ) {
      value.primitiveProperty = {};
    }
    const list = [
      "maxLength",
      "minLength",
      "max",
      "min",
      "precision",
      "maxDate",
      "minDate",
    ];
    list.forEach((key) => {
      if (
        value.primitiveProperty[key] === null ||
        value.primitiveProperty[key] === undefined
      ) {
        value.primitiveProperty[key] = value.templateOptions[key];
      }
    });
    // if (
    //   value.primitiveProperty.maxLength === null ||
    //   value.primitiveProperty.maxLength === undefined
    // ) {
    //   value.primitiveProperty.maxLength = value.templateOptions.maxLength;
    // }
    // if (
    //   value.primitiveProperty.minLength === null ||
    //   value.primitiveProperty.minLength === undefined
    // ) {
    //   value.primitiveProperty.minLength = value.templateOptions.minLength;
    // }
    // if (
    //   value.primitiveProperty.max === null ||
    //   value.primitiveProperty.max === undefined
    // ) {
    //   value.primitiveProperty.max = value.templateOptions.max;
    // }
    // if (
    //   value.primitiveProperty.min === null ||
    //   value.primitiveProperty.min === undefined
    // ) {
    //   value.primitiveProperty.min = value.templateOptions.min;
    // }

    // if (
    //   value.primitiveProperty.precision === null ||
    //   value.primitiveProperty.precision === undefined
    // ) {
    //   value.primitiveProperty.precision = value.templateOptions.precision;
    // }

    // if (
    //   value.primitiveProperty.maxDate === null ||
    //   value.primitiveProperty.maxDate === undefined
    // ) {
    //   value.primitiveProperty.maxDate = value.templateOptions.maxDate;
    // }

    // if (
    //   value.primitiveProperty.minDate === null ||
    //   value.primitiveProperty.minDate === undefined
    // ) {
    //   value.primitiveProperty.minDate = value.templateOptions.minDate;
    // }
  }

  @Input() modalType: string = "default";
  @Input() set options(value: IParameterIdItem[]) {
    value.forEach((el) => {
      if (el.parameterId === this.formField.templateOptions!.parameterId) {
        this.defaultList.push({
          label: el.label,
          value: el.value,
        });
      }
    });
  }

  form = new FormGroup({});

  model: any = {};

  // options = {};

  formFildConfig: KreFormFieldConfig[] = [];
  // multiple = 'default'; // multiple

  public globalSubmit: BehaviorSubject<any> = new BehaviorSubject(String);
  constructor(
    public message: NzMessageService,
    private fb: FormBuilder,
    public kreFormCommonService: KreFormCommonService,
    public kreSetFieldService: KreSetFormFieldService,
    private el: ElementRef
  ) {}

  ngOnInit() {
    for (let i = 12; i <= 20; i++) {
      this.fontSizeList.push(i);
    }
  }

  ngOnChanges(changes: SimpleChanges) {}
  defaultValueChange(e: any, type: "multiple" | "single" | "") {
    this.formField.defaultValue = [];

    if (type === "multiple") {
      if (!_.isEmpty(e as string[])) {
        e!.forEach((el: any) => {
          this.formField.defaultValue.push({
            label: this.defaultList.filter((ele) => ele.value === el)[0][
              "label"
            ],
            value: this.defaultList.filter((ele) => ele.value === el)[0][
              "value"
            ],
          });
        });
      }
    } else {
      this.formField.defaultValue.push({
        label: this.defaultList.filter((ele) => ele.value === e)[0]["label"],
        value: this.defaultList.filter((ele) => ele.value === e)[0]["value"],
      });
    }
  }

  hideSelectChange(e: string[]) {
    if (!_.isEmpty(e)) {
      this.formField!.templateOptions!.hideSelect = [];
      e.forEach((el) => {
        this.formField!.templateOptions!.hideSelect!.push({
          label: this.defaultList.filter((ele) => ele.value === el)[0]["label"],
          value: this.defaultList.filter((ele) => ele.value === el)[0]["value"],
        });
      });
    } else {
      this.formField!.templateOptions!.hideSelect = null;
    }
  }

  checkSave() {
    let type = this.formField.type;
    if (type == "text" || type == "textarea") {
      if (
        _.get(this.formField, "templateOptions.minLength") >=
        _.get(this.formField, "templateOptions.maxLength")
      ) {
        this.message.error("最大长度必须大于最小长度");
        return false;
      }
    }
    if (type == "number") {
      if (
        _.get(this.formField, "templateOptions.min") >=
        _.get(this.formField, "templateOptions.max")
      ) {
        this.message.error("最大值必须大于最小值");
        return false;
      }
    }
    return true;
  }

  tmp = 0;
  initBehaviorSubject(caller: any, callback: any) {
    this.globalSubmit = new BehaviorSubject(String);
    if (callback != undefined && callback != null && callback != "") {
      callback.call(caller);
    }
  }

  frmSubmit() {
    this.el.nativeElement.querySelector("#btn-basic-save").click();
    if (this.form) {
      for (const i in this.form.controls) {
        this.form.controls[i].markAsDirty();
        this.form.controls[i].updateValueAndValidity();
      }
      if (this.form.valid) {
        this.tmp = this.tmp + 1;
        if (this.tmp == 1) {
          this.globalSubmit.next("OK");
          this.getFieldInfo(this.formField);
        }
      }
    }
  }

  ngOnDestroy() {
    this.globalSubmit.unsubscribe();
  }

  getFieldInfo(field: any) {
    if (this.model["editor"] != undefined) {
      field.editor = this.model["editor"];
    }
    if (!this.model.hasOwnProperty("hide")) {
      field.hide = !this.model["show"];
    }
    console.log(field.hide);
    if (this.model["hide"] != undefined && this.model["hide"] != null) {
      field.hide = this.model["hide"];
      field.show != this.model["hide"];
    }

    if (_.get(this.model, "templateOptions.description") != undefined) {
      field["templateOptions"]["description"] = _.get(
        this.model,
        "templateOptions.description"
      );
    }
    if (_.get(this.model, "templateOptions.maxLength") != undefined) {
      field.templateOptions.maxLength = _.get(
        this.model,
        "templateOptions.maxLength"
      );
    }
    if (_.get(this.model, "templateOptions.minLength") != undefined) {
      field.templateOptions.minLength = _.get(
        this.model,
        "templateOptions.minLength"
      );
    }
    if (_.get(this.model, "templateOptions.minLength") != undefined) {
      field.templateOptions.max = _.get(this.model, "templateOptions.max");
    }
    if (_.get(this.model, "templateOptions.min")) {
      field.templateOptions.min = _.get(this.model, "templateOptions.min");
    }
    if (_.get(this.model, "templateOptions.precision") != undefined) {
      field.templateOptions.precision = _.get(
        this.model,
        "templateOptions.precision"
      );
    }
    if (_.get(this.model, "templateOptions.placeholder") != undefined) {
      field.templateOptions.placeholder = _.get(
        this.model,
        "templateOptions.placeholder"
      );
    }
    if (_.get(this.model, "templateOptions.required") != undefined) {
      field.templateOptions.required = _.get(
        this.model,
        "templateOptions.required"
      );
    }
    if (_.get(this.model, "templateOptions.tips") != undefined) {
      field.templateOptions.tips = _.get(this.model, "templateOptions.tips");
    }
    if (_.get(this.model, "templateOptions.pattern") != undefined) {
      field.templateOptions.pattern = _.get(
        this.model,
        "templateOptions.pattern"
      );
    }
    if (_.get(this.model, "templateOptions.rows") != undefined) {
      field.templateOptions.rows = _.get(this.model, "templateOptions.rows");
    }
  }

  fieldHideChange(e: any) {
    this.formField.show = !e;
  }
  nameChange(e: any) {
    this.formField!.templateOptions!.labelI18n = e;

    this.formField!.templateOptions!.label = (
      this.formField!.templateOptions!.labelI18n as any[]
    ).filter((el) => el.language === "zh-cn")[0].value;
  }
  tipsChange(e: any) {
    this.formField!.templateOptions!.tipsI18n = e;
  }
  dateTimeChange(time: any, type: "datetime" | "date" | "year" | "month") {
    if (time) {
      switch (type) {
        case "date":
          time = moment(time).format("YYYY/MM/DD 00:00:00");
          break;
        case "year":
          time = moment(time).format("YYYY/01/01 00:00:00");
          break;

        case "month":
          time = moment(time).format("YYYY/MM/01 00:00:00");
          break;

        default:
          break;
      }
    } else {
      time = "";
    }

    this.formField.defaultValue = time;
  }

  nzDefaultValueMin(): number {
    if (!!this.formField!.templateOptions!["min"]) {
      return Math.max(
        this.limit!["min"],
        this.formField!.templateOptions!["min"]
      );
    } else {
      return this.limit!["min"];
    }
  }

  nzDefaultValueMax(): number {
    if (!!this.formField!.templateOptions!["max"]) {
      return Math.min(
        this.limit!["max"],
        this.formField!.templateOptions!["max"]
      );
    } else {
      return this.limit!["max"];
    }
  }

  nzMaxMin(): number {
    let min = this.limit!["min"];

    if (
      !!this.formField!.templateOptions!["min"] &&
      !!this.formField.defaultValue
    ) {
      min = Math.max(
        this.formField!.templateOptions!["min"],
        this.formField.defaultValue
      );
    } else if (
      !this.formField!.templateOptions!["min"] &&
      !!this.formField.defaultValue
    ) {
      min = this.formField.defaultValue;
    } else if (
      !!this.formField!.templateOptions!["min"] &&
      !this.formField.defaultValue
    ) {
      min = this.formField!.templateOptions!["min"];
    } else {
      min = this.limit!["min"];
    }

    return min;
  }
  nzMaxMax(): number {
    let max = this.limit!["max"];

    return max;
  }

  nzMinMin(): number {
    return this.limit!["min"];
  }
  nzMinMax(): number {
    let max = this.limit!["max"];

    if (
      !!this.formField!.templateOptions!["max"] &&
      !!this.formField.defaultValue
    ) {
      max = Math.min(
        this.formField!.templateOptions!["max"],
        this.formField.defaultValue
      );
    } else if (
      !this.formField!.templateOptions!["max"] &&
      !!this.formField.defaultValue
    ) {
      max = this.formField.defaultValue;
    } else if (
      !!this.formField!.templateOptions!["max"] &&
      !this.formField.defaultValue
    ) {
      max = this.formField!.templateOptions!["max"];
    } else {
      max = this.limit!["max"];
    }

    return max;
  }
}
